<template>
  <div id="deposit-issue-form">
    <v-row align="center" justify="center" v-if="isLoading">
      <RingLoader color="#7ed321" />
    </v-row>
    <v-form @submit="submit" ref="form" v-model="valid" v-if="!isLoading">
      <v-row>
        <v-col cols="12">
          <h2 style="color: #7ed321">บัญชีฝากเงิน</h2>
          <br />
          <v-select
            v-model="select"
            :items="itemsBankprovider"
            :error-messages="selectErrors"
            label="กรุณาเลือกธนาคาร"
            required
            solo-inverted
            return-object
            @change="$v.select.$touch()"
            @blur="$v.select.$touch()"
            :disabled="isSuccess"
            hide-details
            ><template slot="selection" slot-scope="data">
              <img width="20px" class="mr-2" :src="data.item.logo" />
              {{ data.item.name }}
              ({{ data.item.shortname }})
            </template>
            <template slot="item" slot-scope="data">
              <img width="30px" class="mr-2" :src="data.item.logo" />
              {{ data.item.name }}
              ({{ data.item.shortname }})
            </template></v-select
          >
          <v-row style="margin-bottom: 5px">
            <v-col cols="12" style="color: #7ed321; font-size: 12px"
              >Bank account
            </v-col>
          </v-row>
          <v-text-field
            v-if="select"
            v-model="bankAcc"
            :error-messages="bankAccErrors"
            :rules="[rules.bankAccRule(bankAcc, select)]"
            label="กรุณาใส่เลขบัญชี"
            required
            solo-inverted
            @input="$v.bankAcc.$touch()"
            @blur="$v.bankAcc.$touch()"
            :disabled="isSuccess"
            hide-details
          ></v-text-field>
          <v-row v-if="select" style="margin-bottom: 5px">
            <v-col cols="12" style="color: #7ed321; font-size: 12px"
              >Account number
            </v-col>
          </v-row>
          <h2 style="color: #7ed321">ยอดโอน</h2>
          <br />
          <v-text-field
            v-model="transferAmount"
            type="number"
            :error-messages="transferAmountErrors"
            label="0.00"
            required
            solo-inverted
            @input="$v.transferAmount.$touch()"
            @blur="$v.transferAmount.$touch()"
            :disabled="isSuccess"
            hide-details
          ></v-text-field>
          <v-row style="margin-bottom: 5px">
            <v-col cols="12" style="color: #7ed321; font-size: 12px"
              >Transfer amount
            </v-col>
          </v-row>
          <h2 style="color: #7ed321">วันที่โอน</h2>
          <br />
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedDateFormatted"
                label="วันที่โอน"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                solo-inverted
                :disabled="isSuccess"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu = false"
              :max="new Date().toISOString().slice(0, 10)"
            ></v-date-picker>
          </v-menu>
          <v-row style="margin-bottom: 5px">
            <v-col cols="12" style="color: #7ed321; font-size: 12px"
              >Transfer date
            </v-col>
          </v-row>
          <h2 style="color: #7ed321">เวลาโอน</h2>
          <br />
          <v-row>
            <v-col>
              <v-text-field
                v-model="HH"
                type="number"
                label="HH"
                :min="0"
                :max="23"
                :maxlength="2"
                oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                @change="checkHours"
                :disabled="isSuccess"
                required
                @input="$v.HH.$touch()"
                @blur="$v.HH.$touch()"
                hide-details
              ></v-text-field>
              <v-row style="margin-bottom: 5px">
                <v-col cols="12" style="color: #7ed321; font-size: 12px"
                  >Transfer time
                </v-col>
              </v-row>
            </v-col>
            <h1>:</h1>
            <v-col>
              <v-text-field
                v-model="mm"
                type="number"
                label="MM"
                :min="0"
                :max="59"
                oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                @change="checkMinute"
                :disabled="isSuccess"
                required
                @input="$v.mm.$touch()"
                @blur="$v.mm.$touch()"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <h2 style="color: #7ed321">สลิปโอน</h2>
          <br />
          <v-file-input
            v-model="file"
            :rules="[rules.fileRule]"
            :error-messages="fileErrors"
            accept="image/png, image/jpeg"
            label="เลือกไฟล์"
            show-size
            filled
            required
            prepend-icon="mdi-camera"
            @input="$v.file.$touch()"
            @blur="$v.file.$touch()"
            @change="getBase64()"
            id="file"
            :disabled="isSuccess"
            hide-details
          ></v-file-input>
          <v-row style="margin-bottom: 5px">
            <v-col cols="12" style="color: #7ed321; font-size: 12px"
              >Slip
            </v-col>
          </v-row>
          <v-btn
            block
            elevation="2"
            x-large
            @click="submit"
            :style="!$v.$invalid ? 'background-color: #7ed321' : ''"
            :disabled="$v.$invalid || !valid || isSuccess"
          >
            แจ้งปัญหา
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import liff from "@line/liff";
import { RingLoader } from "vue-spinners-css";
import issueService from "../../services/issue_service.js";
import ttb from "../../assets/TTB.jpeg";
import { BANK_ACCOUNT_MAX_LENGTH, bankAccountRule } from "../../config/banks.js";

export default {
  name: "DepositIssueForm",
  components: {
    RingLoader,
  },
  mixins: [validationMixin],
  props: {
    lineId: {
      type: String,
      default: "",
    },
  },
  validations: {
    bankAcc: { required, maxLength: maxLength(BANK_ACCOUNT_MAX_LENGTH) },
    select: { required },
    transferAmount: { required },
    HH: { required },
    mm: { required },
    file: { required },
  },
  data: (vm) => ({
    HH: null,
    mm: null,
    valid: true,
    bankAcc: "",
    transferAmount: "",
    select: null,
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    dateFormatted: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    menu: false,
    file: null,
    itemsBankprovider: [
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FSCB.png?alt=media&token=4bcea6cf-b654-47ce-a099-7ec62c95169f",
        name: "ธนาคารไทยพาณิชย์",
        shortname: "SCB",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FKBNK.png?alt=media&token=9a4c15d8-ef3c-43a4-bc4e-0498b1a7fa1d",
        name: "ธนาคารกสิกรไทย",
        shortname: "KBNK",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FKTBA.png?alt=media&token=f48498e0-331e-484e-98a2-99880d10cb06",
        name: "ธนาคารกรุงไทย",
        shortname: "KTB",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FBBLA.png?alt=media&token=f563a3e0-fcdc-4135-ac8e-878fa44eeaef",
        name: "ธนาคารกรุงเทพ",
        shortname: "BBL",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FBAYA.png?alt=media&token=e3c78d16-0c04-47ae-9280-867aaef46feb",
        name: "ธนาคารกรุงศรีอยุธยา",
        shortname: "BAY",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FGSBA.png?alt=media&token=c0d650ae-6748-445d-bc4f-ce8843b9706c",
        name: "ธนาคารออมสิน",
        shortname: "GSBA",
      },
      {
        logo: ttb,
        name: "ธนาคารทีเอ็มบีธนชาต",
        shortname: "TMB",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FKKBA.png?alt=media&token=ac103755-a94a-40d4-afef-2383dcb73e89",
        name: "ธนาคารเกียรตินาคิน",
        shortname: "KKBA",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FGHBA.png?alt=media&token=4caa517e-2d35-4413-8be9-ddfb09ff88b7",
        name: "ธนาคารอาคารสงเคราะห์",
        shortname: "GHBA",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FBAAC.png?alt=media&token=db135e19-2125-43bb-a4aa-a70b0977f744",
        name: "ธนาคารเพื่อการเกษตรและสหกรณ์",
        shortname: "BAAC",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FUOBT.png?alt=media&token=522b8d11-670c-47f4-b431-e9f199ef1900",
        name: "ยูโอบี",
        shortname: "UOBT",
      },
    ],
    rules: {
      bankAccRule: bankAccountRule,
      fileRule: (value) => {
        return !value || value.size < 5000000 || "ขนาดไฟล์ควรน้อยกว่า 5 MB!";
      },
    },
    isLoading: false,
    isSuccess: false,
    base64: "",
  }),
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.select.$dirty) return errors;
      !this.$v.select.required && errors.push("กรุณาเลือกธนาคาร");
      return errors;
    },
    bankAccErrors() {
      const errors = [];
      if (!this.$v.bankAcc.$dirty) return errors;
      !this.$v.bankAcc.required && errors.push("กรุณาใส่เลขบัญชี");
      return errors;
    },
    transferAmountErrors() {
      const errors = [];
      if (!this.$v.transferAmount.$dirty) return errors;
      !this.$v.transferAmount.required && errors.push("กรุณาใส่ยอดโอน");
      return errors;
    },
    fileErrors() {
      const errors = [];
      if (!this.$v.file.$dirty) return errors;
      !this.$v.file.required && errors.push("ไม่ได้เลือกไฟล์");
      return errors;
    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  methods: {
    getBase64() {
      const file = document.querySelector("input[type=file]").files[0];
      const reader = new FileReader();

      let rawImg;
      if (file.type == "image/png") {
        reader.onloadend = () => {
          rawImg = reader.result;
          var base64 = rawImg.split("data:image/png;base64,");
          this.base64 = base64[1];
        };
      } else if (file.type == "image/jpeg") {
        reader.onloadend = () => {
          rawImg = reader.result;
          var base64 = rawImg.split("data:image/jpeg;base64,");
          this.base64 = base64[1];
        };
      }
      reader.readAsDataURL(file);
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.isLoading = true;
        const dateString =
          this.date + "T" + this.HH + ":" + this.mm + ":00.000+07:00";
        if (new Date(dateString) > new Date()) {
          this.isLoading = false;
          this.$toast.error("กรุณากรอกเวลาให้น้อยกว่าปัจจุบัน", {
            position: "top-center",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false,
          });
          return;
        }
        let body = {
          bankName: this.select.shortname,
          accountNo: this.bankAcc,
          amount: Number(this.transferAmount),
          transactionDate: dateString,
          slip: this.base64,
          lineId: this.lineId,
        };
        issueService
          .createIssue(body)
          .then((res) => {
            this.isSuccess = true;
            this.isLoading = false;
            this.$toast.success(res.data.message, {
              position: "top-center",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
            setTimeout(() => {
              liff.closeWindow();
            }, 2000);
          })
          .catch((error) => {
            this.isLoading = false;
            this.$toast.error(
              error.response && error.response.data
                ? error.response.data.display_message
                : "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
              {
                position: "top-center",
                timeout: 5000,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                closeButton: "button",
                icon: true,
                rtl: false,
              }
            );
          });
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    checkHours() {
      if (this.HH.length == 2) {
        if (this.HH == "00") {
          this.HH = "0";
        } else if (this.HH[0] == "0") {
          let hh = this.HH.split("0");
          this.HH = hh[1];
        }
      }
      if (Number(this.HH) < 10) {
        this.HH = "0" + this.HH;
      }
    },
    checkMinute() {
      if (this.mm.length == 2) {
        if (this.mm == "00") {
          this.mm = "0";
        } else if (this.mm[0] == "0") {
          let hh = this.mm.split("0");
          this.mm = hh[1];
        }
      }
      if (Number(this.mm) < 10) {
        this.mm = "0" + this.mm;
      }
    },
  },
};
</script>
